export const setScaling = (element, isMobile) => {
    if (element.custom?.clipart === 'futbol') {
        element.scaleX = isMobile ? 2 : 1;
        element.scaleY = isMobile ? 2 : 1;
    }
};
